export const generateLabelValues = options =>
  options.map(option => ({ label: option, value: option }))

export const STAR_SIGN_OPTIONS = generateLabelValues([
  'Aquarius',
  'Pisces',
  'Aries',
  'Taurus',
  'Gemini',
  'Cancer',
  'Leo',
  'Virgo',
  'Libra',
  'Scorpio',
  'Sagittarius',
  'Capricorn',
])

export const RELIGION_OPTIONS = [
  { label: 'Buddhist', value: 'Buddhist' },
  { label: 'Catholic', value: 'Catholic' },
  { label: 'Christian', value: 'Christian' },
  { label: 'Hindu', value: 'Hindu' },
  { label: 'Jewish', value: 'Jewish' },
  { label: 'Muslim', value: 'Muslim' },
  { label: 'Spiritual', value: 'Spiritual' },
  { label: 'Agnostic', value: 'Agnostic' },
  { label: 'Atheist', value: 'Atheist' },
  { label: 'Other', value: 'Other' },
  { label: 'Prefer Not to Say', value: 'Prefer Not to Say' },
]

export const ETHNICITY_OPTIONS = generateLabelValues([
  'American Indian',
  'Black/African Descent',
  'East Asian',
  'Hispanic/Latino',
  'Middle Eastern',
  'Pacific Islander',
  'South Asian',
  'White/Caucasian',
  'Other',
])

export const HEIGHT_OPTIONS = generateLabelValues([
  '4’0”',
  '4’1”',
  '4’2”',
  '4’3”',
  '4’4”',
  '4’5”',
  '4’6”',
  '4’7”',
  '4’8”',
  '4’9”',
  '4’10”',
  '4’11”',
  '5’0”',
  '5’1”',
  '5’2”',
  '5’3”',
  '5’4”',
  '5’5”',
  '5’6”',
  '5’7”',
  '5’8”',
  '5’9”',
  '5’10”',
  '5’11”',
  '6’0”',
  '6’1”',
  '6’2”',
  '6’3”',
  '6’4”',
  '6’5”',
  '6’6”',
  '6’7”',
  '6’8”',
  '6’9”',
  '6’10”',
  '6’11”',
  '7’0”',
  '7’1”',
  '7’2”',
])

export const EDUCATION_OPTIONS = generateLabelValues([
  'High school',
  'Undergrad',
  'Post grad',
  'Doctorate',
  'Prefer Not to Say',
])

export const PET_OPTIONS = generateLabelValues(['Dog(s)', 'Cat(s)', 'None', "Don't Want", 'Lots'])

export const EXERCISE_OPTIONS = generateLabelValues([
  'Active',
  'Sometimes',
  'Almost Never',
  'Prefer Not to Say',
])
export const FITNESS_FREQUENCY_OPTIONS = generateLabelValues([
  'Daily',
  '3-6x / Week',
  '1-2x / Week',
  'Once A Week',
  'Occasionally',
  'Rarely',
  'Never',
  'Prefer Not to Say',
])

export const FITNESS_ACTIVITIES_OPTIONS = generateLabelValues([
  'Walking',
  'Yoga',
  'Weightlifting',
  'Running / jogging',
  'Cycling / spinning',
  'Swimming',
  'Pilates',
  'HIIT',
  'CrossFit',
  'Dance Fitness',
  'Sports',
  'Other',
])

export const YES_OPTIONS = generateLabelValues(['Yes', 'Sometimes', 'No'])

export const HAVE_CHILDREN_OPTIONS = generateLabelValues(["Don't have children", 'Have children'])

export const WANT_CHILDREN_OPTIONS = generateLabelValues([
  "Don't want children",
  'Want children',
  'Open to children',
])

export const WANT_FAMILY_OPTIONS = generateLabelValues([
  "Don't want to start a family",
  'Want to start a family',
  'Open to start a family',
  'Not sure yet',
  'Prefer not to say',
])

export const LOOKING_FOR_OPTIONS = generateLabelValues([
  'Something casual',
  'Relationship',
  "I don't know",
])

export const DATE_GLOBAL_OPTIONS = generateLabelValues(['Yes', 'No', 'For the Right Person'])

export const POLITICS_OPTIONS = generateLabelValues([
  'Conservative',
  'Liberal',
  'Moderate',
  'Socialist',
  'Environmentalist',
  'Nationalist',
  'Communist',
  'Anarchist',
  'Theocratic',
  'Libertarian',
  'Other',
  'I am not interested in politics',
  'Prefer not to say',
])

export const DIET_OPTIONS = generateLabelValues([
  'Omnivore',
  'Flexitarian',
  'Vegetarian',
  'Pescatarian',
  'Vegan',
  'Ketogenic',
  'Paleolithic',
  'Mediterranean',
  'Gluten-Free',
  'Raw Food',
  'Intermittent Fasting',
  'Macrobiotic',
  'Kosher',
  'I eat everything',
  'Other',
  'Prefer Not to Say',
])

export const INTEREST_OPTIONS = generateLabelValues([
  'Yoga',
  'Music',
  'Cat Lover',
  'Foodie',
  'Writer',
  'Blogging',
  'Sports',
  'Politics',
  'Instagram',
  'Fashion',
  'Volunteering',
  'Picnicking',
  'Fishing',
  'Dancing',
  'Working Out',
  'Swimming',
  'Cooking',
  'Netflix',
  'Astrology',
  'Comedy',
  'Gardening',
  'Reading',
  'Gamer',
  'Vlogging',
  'Karaoke',
  'Running',
  'Environmentalism',
  'Travel',
  'Movies',
  'Tea',
  'Cycling',
  'Outdoors',
  'Craft Beer',
  'Dog Lover',
  'Wine',
  'Shopping',
  'Grab a Drink',
  'Coffee',
  'Climbing',
  'Museum',
  'Art',
  'Athlete',
  'DIY',
  'Soccer',
  'Surfing',
  'Hiking',
  'Language Exchange',
  'Brunch',
  'Walking',
  'Baking',
  'Trivia',
  'Spirituality',
  'Board Games',
  'Golf',
  'Disney',
  'Photography',
])

export const CAREER_GOALS_OPTIONS = generateLabelValues([
  'Highly Ambitious',
  'Stable',
  'Balance',
  'Retired',
  'Not A Priority',
])

export const RELATIONSHIP_MODEL_OPTIONS = generateLabelValues([
  'Monogamy',
  'Polyamory',
  'Open Relationship',
  'Other',
  'Prefer Not to Say',
])
export const INTENTION_OPTIONS = generateLabelValues([
  'Life Partner',
  'Long Term Relationship',
  'Short Term Relationship',
  'Long-term relationship, open to short',
  'Short-term relationship, open to long',
  'Figuring Out My Dating Goals',
  'Prefer Not to Say',
])

export const USER_DATA_LOCATION = {
  USER_IMAGES: 'images',
  USER_CORE: '',
  USER_PROFILE: 'profile',
  USER_INTERESTS: 'interests',
}

// ====================== PROFILE ======================

// ---------- ALCOHOL (PROFILE) ----------
export const ALCOHOL_PROFILE_YES_OPTIONS = generateLabelValues([
  'I drink socially, mostly during gatherings and celebrations',
  'I enjoy a drink or two daily to relax after work',
  'I often explore different types of alcoholic beverages for taste and experience',
  'My consumption is mostly limited to weekends and special occasions',
  'I consider myself a connoisseur, with a keen interest in fine wines, craft beers, or spirits',
])

export const ALCOHOL_PROFILE_SOMETIMES_OPTIONS = generateLabelValues([
  'I enjoy a glass of wine with dinner occasionally',
  'I might have a drink during social events, but not regularly',
  'I indulge in a few drinks during holidays or very special occasions only',
  'My consumption is infrequent, perhaps a few times a month',
  'I enjoy experimenting with cocktails or new drinks, but sparingly',
])

export const ALCOHOL_PROFILE_NO_OPTIONS = generateLabelValues([
  'I abstain from alcohol for health reasons',
  "I've never developed a taste for alcoholic beverages",
  'I choose not to drink for personal or religious reasons',
  'I used to drink, but have since decided to live an alcohol-free lifestyle',
  'I prefer non-alcoholic alternatives when socializing or dining out',
])

// ---------- DRUGS (PROFILE) ----------
export const DRUGS_PROFILE_YES_OPTIONS = generateLabelValues([
  'I regularly use substances for recreational purposes, including party drugs, to enhance social experiences',
  'My use includes psychedelics, which I explore for their mind-expanding properties or for personal growth',
  'I engage in the use of various substances to explore different states of consciousness or for creative inspiration',
  'My drug use is part of a lifestyle choice, and I am knowledgeable about harm reduction practices',
  'I use drugs in a controlled and informed manner, focusing on safety and setting',
])

export const DRUGS_PROFILE_SOMETIMES_OPTIONS = generateLabelValues([
  'I occasionally use drugs in social settings or at events where they are present',
  'My use of psychedelics is infrequent and approached with intention, often for spiritual or self-exploratory reasons',
  'I partake in the use of party drugs or psychedelics a few times a year, focusing on safety and moderation',
  'I am open to experimenting with substances but do so sparingly and with careful consideration of the risks',
  'I explore the use of drugs as a way to enhance certain experiences, but I am cautious and selective about it',
])

export const DRUGS_PROFILE_NO_OPTIONS = generateLabelValues([
  'I abstain from drug use for health, legal, or personal reasons',
  'I have never used drugs and prefer other ways to enjoy or explore experiences',
  'I used to experiment with drugs but have since chosen to stop for my well-being',
  'While I support informed adult choices, I personally choose not to use drugs',
  'I am interested in the research and discussions around psychedelics and drug policy, though I do not partake myself',
])

// ---------- CANNABIS (PROFILE) ----------
export const CANNABIS_PROFILE_YES_OPTIONS = generateLabelValues([
  'I use cannabis daily for medicinal purposes',
  'I enjoy recreational cannabis use regularly to relax or enhance experiences',
  'I participate in social cannabis use with friends or at gatherings',
])

export const CANNABIS_PROFILE_SOMETIMES_OPTIONS = generateLabelValues([
  'I occasionally use cannabis for relaxation or social purposes',
  'My use is infrequent and situational',
  'I might partake in cannabis use during special events or with friends',
  'I am open to using cannabis but do so sparingly and responsibly',
  'I explore cannabis in a controlled manner, focusing on its medicinal benefits',
])

export const CANNABIS_PROFILE_NO_OPTIONS = generateLabelValues([
  'I abstain from cannabis use for personal, health, or legal reasons',
  'I have never used cannabis and have no interest in trying it',
  'I used to use cannabis but have since stopped for lifestyle or personal reasons',
  'I support cannabis legalization and research, though I choose not to partake myself',
])

// ---------- TOBACCO (PROFILE) ----------
export const SMOKING_PROFILE_YES_OPTIONS = generateLabelValues([
  'I smoke cigarettes daily',
  'I use smokeless tobacco products regularly',
  'I enjoy cigars or pipe tobacco on special occasions or socially',
  'My tobacco use includes vaping or e-cigarettes on a regular basis',
])

export const SMOKING_PROFILE_SOMETIMES_OPTIONS = generateLabelValues([
  'I occasionally smoke socially or in social settings where others are smoking',
  'I might use tobacco products infrequently, such as during high stress periods or at parties',
  'My use is limited to certain types of tobacco, like cigars at celebrations',
  'I engage in vaping or e-cigarettes, but not on a daily basis',
  'I am an experimental user, trying different tobacco products, but not regularly',
])

export const SMOKING_PROFILE_NO_OPTIONS = generateLabelValues([
  'I have quit using tobacco products and now live a tobacco-free lifestyle',
  'I have never used tobacco products and have no interest in starting',
  'I avoid tobacco for health reasons or due to personal preferences',
])

// ====================== PREFERENCES ======================

// ---------- ALCOHOL (PREFERENCE) ----------
export const ALCOHOL_PREFERENCE_YES_OPTIONS = generateLabelValues([
  'Drinks socially, mostly during gatherings and celebrations',
  'Enjoys a drink or two daily to relax after work',
  'Often explores different types of alcoholic beverages for taste and experience',
  'Consumption is mostly limited to weekends and special occasions',
  'Considers themself a connoisseur, with a keen interest in fine wines, craft beers, or spirits',
])

export const ALCOHOL_PREFERENCE_SOMETIMES_OPTIONS = generateLabelValues([
  'Enjoys a glass of wine with dinner occasionally',
  'Might have a drink during social events, but not regularly',
  'Indulges in a few drinks during holidays or very special occasions only',
  'Consumption is infrequent, perhaps a few times a month',
  'Enjoys experimenting with cocktails or new drinks, but sparingly',
])

export const ALCOHOL_PREFERENCE_NO_OPTIONS = generateLabelValues([
  'Abstains from alcohol for health reasons',
  'Never developed a taste for alcoholic beverages',
  'Chooses not to drink for personal or religious reasons',
  'Used to drink, but have since decided to live an alcohol-free lifestyle',
  'Prefers non-alcoholic alternatives when socializing or dining out',
])

// ---------- DRUGS (PREFERENCE) ----------
export const DRUGS_PREFERENCE_YES_OPTIONS = generateLabelValues([
  'Regularly uses substances for recreational purposes, including party drugs, to enhance social experiences',
  'Their use includes psychedelics, which I explore for their mind-expanding properties or for personal growth',
  'Engages in the use of various substances to explore different states of consciousness or for creative inspiration',
  'Drug use is part of a lifestyle choice, and is knowledgeable about harm reduction practices',
  'Uses drugs in a controlled and informed manner, focusing on safety and setting',
])

export const DRUGS_PREFERENCE_SOMETIMES_OPTIONS = generateLabelValues([
  'Occasionally uses drugs in social settings or at events where they are present',
  'Use of psychedelics is infrequent and approached with intention, often for spiritual or self-exploratory reasons',
  'Partakes in the use of party drugs or psychedelics a few times a year, focusing on safety and moderation',
  'Is open to experimenting with substances but does so sparingly and with careful consideration of the risks',
  'Explores the use of drugs as a way to enhance certain experiences, but is cautious and selective about it',
])

export const DRUGS_PREFERENCE_NO_OPTIONS = generateLabelValues([
  'Abstains from drug use for health, legal, or personal reasons',
  'Has never used drugs and prefer other ways to enjoy or explore experiences',
  'Used to experiment with drugs but have since chosen to stop for their well-being',
  'Supports informed adult choices, but personally chooses not to use drugs',
  'Is interested in the research and discussions around psychedelics and drug policy, though does not partake myself',
])

// ---------- CANNABIS (PREFERENCE) ----------
export const CANNABIS_PREFERENCE_YES_OPTIONS = generateLabelValues([
  'Uses cannabis daily for medicinal purposes',
  'Enjoys recreational cannabis use regularly to relax or enhance experiences',
  'Participates in social cannabis use with friends or at gatherings',
])

export const CANNABIS_PREFERENCE_SOMETIMES_OPTIONS = generateLabelValues([
  'Occasionally uses cannabis for relaxation or social purposes',
  'Use is infrequent and situational',
  'Might partake in cannabis use during special events or with friends',
  'Is open to using cannabis but do so sparingly and responsibly',
  'Explores cannabis in a controlled manner, focusing on its medicinal benefits',
])

export const CANNABIS_PREFERENCE_NO_OPTIONS = generateLabelValues([
  'Abstains from cannabis use for personal, health, or legal reasons',
  'Has never used cannabis and have no interest in trying it',
  'Used to use cannabis but have since stopped for lifestyle or personal reasons',
  'Supports cannabis legalization and research, though chooses not to partake myself',
])

// ---------- TOBACCO (PREFERENCE) ----------
export const SMOKING_PREFERENCE_YES_OPTIONS = generateLabelValues([
  'Smokes cigarettes daily',
  'Uses smokeless tobacco products regularly',
  'Enjoys cigars or pipe tobacco on special occasions or socially',
  'Tobacco use includes vaping or e-cigarettes on a regular basis',
])

export const SMOKING_PREFERENCE_SOMETIMES_OPTIONS = generateLabelValues([
  'Occasionally smokes socially or in social settings where others are smoking',
  'Might use tobacco products infrequently, such as during high stress periods or at parties',
  'Use is limited to certain types of tobacco, like cigars at celebrations',
  'Engages in vaping or e-cigarettes, but not on a daily basis',
  'Is an experimental user, trying different tobacco products, but not regularly',
])

export const SMOKING_PREFERENCE_NO_OPTIONS = generateLabelValues([
  'Has quit using tobacco products and now lives a tobacco-free lifestyle',
  'Has never used tobacco products and have no interest in starting',
  'Avoids tobacco for health reasons or due to personal preferences',
])
